export interface DashboardMetrics {
  totalLeads: number
  totalLeadsChange: number // % change vs prior period
  avgCvr: number
  avgCvrChange: number
  activeTests: number
  activeTestsChange: number
}

export const mockDashboardMetrics: DashboardMetrics = {
  totalLeads: 24_837,
  totalLeadsChange: 12.4,
  avgCvr: 34.2,
  avgCvrChange: 2.1,
  activeTests: 3,
  activeTestsChange: 50,
}

export interface LeadTrendDay {
  date: string
  leads: number
  cvr: number
}

// 30 days of mock trend data
export const mockLeadTrends: LeadTrendDay[] = Array.from(
  { length: 30 },
  (_, i) => {
    const d = new Date(2026, 0, 7 + i) // Jan 7 – Feb 5
    const base = 700 + Math.round(Math.sin(i / 4) * 150)
    const weekday = d.getDay()
    const weekendDip = weekday === 0 || weekday === 6 ? -180 : 0
    return {
      date: `${d.getMonth() + 1}/${d.getDate()}`,
      leads: Math.max(
        350,
        base + weekendDip + Math.round((Math.random() - 0.5) * 100),
      ),
      cvr: +(30 + Math.sin(i / 5) * 4 + (Math.random() - 0.5) * 3).toFixed(1),
    }
  },
)

export interface PartnerPerformance {
  partner: string
  leads: number
  cvr: number
}

export const mockPartnerPerformance: PartnerPerformance[] = [
  { partner: 'NDR', leads: 6_420, cvr: 38.1 },
  { partner: 'NerdWallet', leads: 5_180, cvr: 35.4 },
  { partner: 'SROI', leads: 4_750, cvr: 33.9 },
  { partner: 'SROI 2', leads: 3_920, cvr: 31.2 },
]
